var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.currentComponent.component,
    _vm._b({ tag: "component" }, "component", _vm.currentComponent.model, false)
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }